export const DUPLICATE_DMX_DEVICE_PRESETS = 'DUPLICATE_DMX_DEVICE_PRESETS';
export const DUPLICATE_DMX_DEVICE_PRESETS_SUCCESSFUL = 'DUPLICATE_DMX_DEVICE_PRESETS_SUCCESSFUL';
export const DUPLICATE_DMX_DEVICE_PRESETS_FAILED = 'DUPLICATE_DMX_DEVICE_PRESETS_FAILED';
